export default {"src":"/_next/static/media/JOBY.71cf5993.svg","height":18,"width":18};